import { useQuery } from "@tanstack/react-query"
import { getAllOvertimeReasons } from "../api/overtimeReasonApi";

export const useOvertimeReasons = () => {
    return useQuery({
        queryKey: ['overtime-reasons'],
        queryFn: getAllOvertimeReasons
    });
}